"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _imask = _interopRequireDefault(require("imask"));

var _utils = require("@material-ui/core/utils");

var _Input = _interopRequireDefault(require("../input/Input"));

var _CustomDateMask = _interopRequireDefault(require("../date-input/CustomDateMask"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomIMask = /*#__PURE__*/function (_IMask$InputMask) {
  (0, _inherits2.default)(CustomIMask, _IMask$InputMask);

  var _super = _createSuper(CustomIMask);

  function CustomIMask() {
    (0, _classCallCheck2.default)(this, CustomIMask);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CustomIMask, [{
    key: "maskEquals",
    value: // This override should extend the maskEquals conditional for CustomDateMask case
    // The original method includes the following expresion:
    // mask === Date && this.masked instanceof MaskedDate
    function maskEquals(mask) {
      return (0, _get2.default)((0, _getPrototypeOf2.default)(CustomIMask.prototype), "maskEquals", this).call(this, mask) || mask === _CustomDateMask.default && this.masked instanceof _imask.default.MaskedDate;
    }
  }]);
  return CustomIMask;
}(_imask.default.InputMask);

var MaskedInput = /*#__PURE__*/(0, _react.forwardRef)(function MaskedInput(props, ref) {
  var getRawValue = props.getRawValue,
      inputRefProp = props.inputRef,
      maskOptions = props.maskOptions,
      onChange = props.onChange,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["getRawValue", "inputRef", "maskOptions", "onChange"]);
  var inputRef = (0, _react.useRef)(null);
  var maskInstanceRef = (0, _react.useRef)(null); // handle our inputRef and the one from the props in a single one

  var handleInputRef = (0, _utils.useForkRef)(inputRef, inputRefProp); // create the instance of the IMask

  (0, _react.useEffect)(function () {
    if (!maskInstanceRef.current && inputRef.current) {
      maskInstanceRef.current = new CustomIMask(inputRef.current, maskOptions);
      maskInstanceRef.current.on('accept', function () {
        if (onChange) {
          var event = {
            currentTarget: inputRef.current,
            target: inputRef.current,
            type: 'change'
          };
          event.target.value = maskInstanceRef.current.value;
          event.target.rawValue = getRawValue(maskInstanceRef.current);
          onChange(event);
        }
      });
    }

    return function () {
      if (maskInstanceRef.current) {
        maskInstanceRef.current.off('accept');
        maskInstanceRef.current.destroy();
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // update the mask if the options change

  (0, _react.useEffect)(function () {
    if (maskInstanceRef.current) {
      maskInstanceRef.current.updateOptions(maskOptions);
    }
  }, [maskOptions]);
  return /*#__PURE__*/_react.default.createElement(_Input.default, Object.assign({}, otherProps, {
    ref: ref,
    inputRef: handleInputRef
  }));
});
MaskedInput.defaultProps = {
  getRawValue: function getRawValue(mask) {
    return mask.unmaskedValue;
  }
};
MaskedInput.propTypes = {
  /**
   * A function to extract the raw value from the mask, by default it is using
   * the `unmaskedValue` prop from the IMask instance.
   *
   * The raw value is attached to the event.target.
   *
   * It is useful in case that representation of the value is not useful for your component.
   */
  getRawValue: _propTypes.func,

  /**
   * @ignore
   */
  inputRef: _propTypes.any,

  /**
   * Refer to [IMask documentation](https://imask.js.org/guide.html#masked).
   */
  maskOptions: (0, _propTypes.shape)({
    mask: _propTypes.any.isRequired
  }).isRequired,

  /**
   * Callback fired when the value is changed.
   *
   * __Note:__ The event is not a real DOM event, it is an Object that contains
   * `currentTarget`, `target` and `type` properties to fake it. This is because
   * the underlying library updates the input value manually and when you do that
   * the browsers do not trigger a change event.
   *
   * @param {object} event The event source of the callback.
   */
  onChange: _propTypes.func
};
var _default = MaskedInput;
exports.default = _default;
